import { Navigate, useNavigate, useParams } from 'react-router';

import { ScenarioRoutePaths } from '@app-velocity/modules/scenarios';
import { useCurrentTeamPermissions } from '@app-velocity/libs/team-permissions';

import { SelectFlowContext } from '../context/SelectFlowContext';
import { SelectFlow } from '..';

export const SelectFlowAuth = () => {
  const { teamId, workspaceId } = useParams<{
    teamId: string;
    workspaceId: string;
  }>();

  const currentTeam = useCurrentTeamPermissions();

  const navigate = useNavigate();

  const configureFlow = (nodeId: string) => {
    navigate(
      ScenarioRoutePaths.configureNewChallenge(teamId!, workspaceId!, nodeId)
    );
  };

  if (!currentTeam || !currentTeam.canRunSimulations(1)) {
    return <Navigate to="/" />;
  }

  return (
    <SelectFlowContext.Provider
      value={{
        mode: 'authorized',
        configureFlow: configureFlow,
        workspaceId,
        teamId,
      }}
    >
      <SelectFlow />
    </SelectFlowContext.Provider>
  );
};
